import { getPersonasSinAlta } from "../../services/citas";
import { quitarAcentos, normalizarCURP } from "../validaciones/identidad";

/**
 * Prellenado de Alta Paciente con los datos que ya conoce la Agenda (PacienteCita).
 *
 * - Fuente: la persona agendada sin expediente (capturada por el médico en
 *   ModalCita o, en el futuro, por el formulario que llena el paciente).
 * - Solo devuelve los campos que SÍ tienen valor, para no borrar nada
 *   que el formulario ya tenga.
 * - NO valida ni corrige datos: las validaciones viven en AltaPaciente.
 *   Solo aplica las MISMAS normalizaciones que Alta ya hace al capturar
 *   (sin acentos en nombres, CURP normalizada) y traduce formatos.
 *
 * Devuelve null si la persona no existe o ya tiene expediente.
 */

// Sexo BIOLÓGICO: la agenda lo guarda como M/F/O (igual que Paciente.sexo);
// el select de Alta usa estos textos. Solo es traducción de formato.
// El sexo RENAPO (sexoCURP) NO se prellena: Alta lo calcula desde la CURP.
const SEXO_A_FORMULARIO = { M: "Hombre", F: "Mujer", O: "Intersexual" };

// Misma normalización que Alta aplica al salir de los campos de nombre
const limpiarNombre = (valor) => (valor ? quitarAcentos(String(valor).trim()) : null);

export const obtenerPrellenadoDesdeAgenda = async (pacienteCitaId) => {
  if (!pacienteCitaId) return null;

  const personas = await getPersonasSinAlta();
  const persona = personas.find((p) => p.id === pacienteCitaId);

  if (!persona) return null;

  const campos = {
    nombre: limpiarNombre(persona.nombre),
    apellido_paterno: limpiarNombre(persona.apellido_paterno),
    apellido_materno: limpiarNombre(persona.apellido_materno),
    fecha_nacimiento: persona.fecha_nacimiento,
    sexo: SEXO_A_FORMULARIO[persona.sexo] || null,
    curp: persona.curp ? normalizarCURP(persona.curp) : null,
    telefono: persona.telefono,
    correo: persona.correo,
  };

  // Quitar vacíos para no sobrescribir con null / ""
  return Object.fromEntries(
    Object.entries(campos).filter(
      ([, valor]) => valor !== null && valor !== undefined && String(valor).trim() !== ""
    )
  );
};